export default "__VITE_ASSET__xrkeWwTD__"